import {Button, Col, Row, Space} from "antd";
import {useNavigate} from "react-router-dom";
import {StyledServiceButtonWrapper} from "../../../../styles/onboarding/onboarding";
import {useGetLiveEventContext} from "../context/get-live-event";
import {FormWrapper} from "../../../../components/form-wrapper";
import {LiveEventCohostFormFieldsProps} from "../../../../components/offering-form/live-events/co-host/types";
import {LiveEventCohostFormFields} from "../../../../components/offering-form/live-events/co-host";

export function EditLiveEventCohost() {
  const {
    state: {liveEventData},
  } = useGetLiveEventContext();

  const navigate = useNavigate();

  const liveEventDataProp: LiveEventCohostFormFieldsProps["liveEventData"] = {
    id: liveEventData.id,
    slug: liveEventData.slug,
    tiny_url: liveEventData.tiny_url,
    name: liveEventData.name,
  };

  function handleBack() {
    navigate("/live-classes");
  }

  return (
    <FormWrapper>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <LiveEventCohostFormFields liveEventData={liveEventDataProp} />

        <Row gutter={[0, 16]}>
          <Col span={24} sm={12}>
            <StyledServiceButtonWrapper>
              <Button
                className="secondary-btn"
                onClick={handleBack}
                block
                size="small"
                type="default"
              >
                Back
              </Button>
              <Button
                block
                type="primary"
                htmlType={"button"}
                onClick={handleBack}
                size="small"
              >
                Update live event
              </Button>
            </StyledServiceButtonWrapper>
          </Col>
        </Row>
      </Space>
    </FormWrapper>
  );
}
